import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import Icon, { HomeOutlined } from '@ant-design/icons';
import { Outlet, useNavigate } from "react-router-dom";
import { Menu, Layout, Button, message } from "antd";
import { isCanOnlineUpload } from '../../http/modules/organization'
import img from '../../img/header.png'
import { createFromIconfontCN } from '@ant-design/icons';
const { Content, Sider } = Layout;


export default function Index(props) {

  // icon
  const IconFont = createFromIconfontCN({ scriptUrl: '//at.alicdn.com/t/c/font_4294234_e01tufdvs7j.js' });

  const flag = localStorage.getItem('flag')

  //申报是否结束
  const [isCanOnlineUploads, setIsCanOnlineUploads] = useState()

  function getItem(label, key, icon, children,) {
    return { label, key, icon, children, };
  }
  const items = [
    getItem('机构中心', 'homeCentre'),
    getItem('授课人管理', 'personnel', '', [
      getItem('新增授课人', 'personnelAdd'),
      getItem('授课人列表', 'personnelList'),
    ]),
    getItem('申报管理', 'apply', '', [
      getItem('新增申报', 'applyAdd'),
      getItem('申报列表', 'applyList'),
    ]),
  ];
  const items2 = [
    getItem('账号信息', 'homeProvince', <IconFont type={'icon-yingyong'} />),
    getItem('作品管理', 'worksAdmin', <IconFont type={'icon-shipinbofang'} />, [
      getItem('全部作品', 'oeuvre'),
      getItem('审核列表', 'auditList'),
      getItem('推荐列表', 'recommendationList'),
    ]),
  ]

  // 点击当前菜单跳转页面
  const navigate = useNavigate();

  const clickMenu = (e) => {
    if (e.key == 'applyAdd' && isCanOnlineUploads == -1) {
      message.error('申报已结束')
      return
    }
    if (e.item.props.ispopup) {
      navigate('masking', { state: { uuid: e.item.props.uuid } })
    } else {
      navigate(e.key);
    }
  };

  const dataScreenRef = useRef(null);
  useLayoutEffect(() => {
    setScale()
  }, []);
  const setScale = () => {
    let designWidth = 1920;//设计稿的宽度，根据实际项目调整
    let designHeight = 1080;//设计稿的高度，根据实际项目调整
    let scale = document.documentElement.clientWidth / document.documentElement.clientHeight < designWidth / designHeight ?
      (document.documentElement.clientWidth / designWidth) :
      (document.documentElement.clientHeight / designHeight);
    if (dataScreenRef.current) {
      dataScreenRef.current.style.transform = `scale(${scale}) translate(-50%, -50%)`
    }
  }

  window.onresize = function () {
    setScale()
  }

  //申报结束时间
  const OnIsCanOnlineUpload = async () => {
    try {
      const res = await isCanOnlineUpload({});
      if (res?.code == 0) {
        setIsCanOnlineUploads(res?.data?.isCanOnlineUpload)
      }
    } catch (err) {
      message.error(err.response.data?.msg);
    }
  };

  useEffect(() => {
    OnIsCanOnlineUpload()
  }, [])

  return (
    <div className="dataScreen" ref={dataScreenRef}>
      <div className='layout'>
        <header className='header'>
          <div className='headerImg'>
            <img src={img} alt="" />
            {/* <div>
            <p>企业微课</p>
            <span>Enterprise Microcourse</span>
          </div> */}
          </div>
          <div className='tuiChu' onClick={() => {
            localStorage.removeItem('token'); localStorage.removeItem('flag'); navigate('/')
          }}>
            退出
          </div>
        </header>
        <Layout className='layout' style={{ height: '90%' }}>
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={broken => {
            }}
            onCollapse={(collapsed, type) => {
            }}
          >
            <div className="logo" />
            <Menu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={['homeCentre', 'homeProvince']}
              defaultOpenKeys={['worksAdmin']}
              items={flag == 'org' ? items : items2}
              onClick={clickMenu}
            />
          </Sider>
          <Layout>
            <Content>
              <div style={{ padding: '37px ,0 ,0 54px' }}>
                <Outlet></Outlet>
              </div>
            </Content>
          </Layout>
        </Layout>
      </div>
    </div>

  )
}
